import RuleEdit from '../../../../../components/ruleengine/RuleEdit';
import {AUTHORITY_CREATE_RULE, AUTHORITY_READ_RULE} from '../../../../../modules/ruleengine/config/consts';
import showFunction from '../showFunction';
import {RouteConfig} from '@deviceinsight/ng-ui-scale-lib/api';

export const editRoute = {
	relativePath: ':ruleId',
	label: {
		id: 'assetgroup.detail.ruleengine.edit.title',
		defaultValue: 'Edit Rule'
	},
	component: RuleEdit,
	requiredAuthorities: [AUTHORITY_READ_RULE],
	show: showFunction
} satisfies RouteConfig;

export const createRoute = {
	relativePath: 'create',
	label: {
		id: 'assetgroup.detail.ruleengine.add.title',
		defaultValue: 'Add Rule'
	},
	component: RuleEdit,
	requiredAuthorities: [AUTHORITY_CREATE_RULE],
	show: showFunction
} satisfies RouteConfig;
